export const BREAK_POINTS = {
  xSmall: '480px',
  small: '720px',
  medium: '1024px',
  large: '1280px',
  xLarge: '1920px',
};
